import _mergeJSXProps3 from "@vue/babel-helper-vue-jsx-merge-props";
import _mergeJSXProps2 from "@vue/babel-helper-vue-jsx-merge-props";
import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import omit from 'object.omit';
import { isDate, format as formatDate } from 'date-fns';
import { isEqual, isArray } from '@cloud-sn/v-utils';
import { VMultiCalendar, VPicker } from '@cloud-sn/v-datepicker';
import { buildComponentName } from '../utils';
import localeCN from './locale/zh_CN';
import Icon from '../icon';
var DEFAULT_SIZE_MAP = {
  small: 'sm',
  large: 'lg'
};
var MULTI_FORMAT_SEPARATOR = ', ';

function getFormatValue(value, format) {
  return value.map(function (v) {
    return formatDate(v, format);
  });
}

export default {
  name: buildComponentName('MultiDateicker'),
  props: _objectSpread({}, omit(VPicker.props, ['destroyPopupOnHide', 'showOk', 'showToday']), {
    prefixCls: {
      type: String,
      default: 'ux-calendar'
    },
    locale: {
      type: Object,
      default: function _default() {
        return localeCN.lang;
      }
    },
    pickerValue: {
      type: Date,
      default: function _default() {
        return new Date();
      }
    },
    value: {
      type: [Date, Array],
      default: function _default() {
        return [];
      }
    },
    visible: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    format: {
      type: String,
      default: 'YYYY-MM-DD'
    },
    showDateInput: {
      type: Boolean,
      default: true
    },
    disabledDate: {
      type: Function,
      default: function _default() {
        return false;
      }
    },
    allowClear: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'default',
      validator: function validator(value) {
        return ['small', 'large', 'default'].indexOf(value) > -1;
      }
    }
  }),
  data: function data() {
    return {
      innerValue: null,
      innerVisible: false
    };
  },
  computed: {
    pickerClasses: function pickerClasses() {
      var _ref;

      var prefixCls = this.prefixCls,
          size = this.size;
      return _ref = {}, _defineProperty(_ref, "".concat(prefixCls, "-picker"), true), _defineProperty(_ref, "".concat(prefixCls, "-picker-").concat(size), true), _ref;
    },
    pickerInputClass: function pickerInputClass() {
      var _ref2;

      var prefixCls = this.prefixCls,
          disabled = this.disabled,
          size = this.size;
      var inputPrefix = 'ux-input';
      return _ref2 = {}, _defineProperty(_ref2, inputPrefix, true), _defineProperty(_ref2, "".concat(prefixCls, "-picker-input"), true), _defineProperty(_ref2, "".concat(inputPrefix, "-disabled"), disabled), _defineProperty(_ref2, "".concat(inputPrefix, "-").concat(DEFAULT_SIZE_MAP[size]), size !== 'default'), _ref2;
    },
    normalizeLocale: function normalizeLocale() {
      var locale = this.locale;

      if (!locale) {
        return localeCN.lang;
      }

      return locale.lang ? locale.lang : locale;
    },
    dateInputPlaceholder: function dateInputPlaceholder() {
      var placeholder = this.placeholder,
          normalizeLocale = this.normalizeLocale;
      return placeholder || normalizeLocale && normalizeLocale.multiPlaceholder;
    },
    isCanClear: function isCanClear() {
      var disabled = this.disabled,
          allowClear = this.allowClear,
          innerValue = this.innerValue;
      return !disabled && allowClear && innerValue;
    },
    currentPickerValue: function currentPickerValue() {
      var innerValue = this.innerValue,
          pickerValue = this.pickerValue;
      return innerValue[innerValue.length - 1] || pickerValue || new Date();
    },
    formatValue: function formatValue() {
      var innerValue = this.innerValue,
          format = this.format;
      return getFormatValue(innerValue, format).join(MULTI_FORMAT_SEPARATOR);
    }
  },
  watch: {
    value: function value(nVal) {
      this.setInnerValue(nVal, false);
    },
    visible: function visible(nVal) {
      this.setInnerVisible(nVal);
    }
  },
  created: function created() {
    var value = this.value,
        setInnerValue = this.setInnerValue,
        visible = this.visible,
        setInnerVisible = this.setInnerVisible;
    setInnerValue(value, false);
    setInnerVisible(visible);
  },
  methods: {
    setInnerValue: function setInnerValue(value) {
      var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var innerValue = this.innerValue,
          format = this.format;
      var val = isArray(value) ? value : [value];
      val = val.filter(function (v) {
        return isDate(v);
      });
      this.innerValue = val;

      if (trigger && !isEqual(innerValue, val)) {
        var formatValue = getFormatValue(val, format).join(MULTI_FORMAT_SEPARATOR);
        this.$emit('input', val);
        this.$emit('change', val, formatValue);
      }
    },
    setInnerVisible: function setInnerVisible(visible) {
      this.innerVisible = visible;
    },
    onVisibleChange: function onVisibleChange(visible) {
      this.setInnerVisible(visible); // modify .sync

      this.$emit('update:visible', visible);
      this.$emit('open-change', visible);
    },
    onClear: function onClear(e) {
      e.stopPropagation();
      e.preventDefault();
      this.setInnerValue(null);
    },
    onSelect: function onSelect() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      this.$emit.apply(this, ['select'].concat(args));
    },
    onUnSelect: function onUnSelect() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      this.$emit.apply(this, ['unselect'].concat(args));
    },
    onPanelChange: function onPanelChange() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      this.$emit.apply(this, ['panel-change'].concat(args));
    },
    onOk: function onOk(value) {
      var setInnerValue = this.setInnerValue,
          setInnerVisible = this.setInnerVisible;
      setInnerValue(value);
      setInnerVisible(false);
      this.$emit('ok', value);
    },
    renderTriggerSlot: function renderTriggerSlot() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          disabled = this.disabled,
          formatValue = this.formatValue,
          pickerClasses = this.pickerClasses,
          pickerInputClass = this.pickerInputClass,
          dateInputPlaceholder = this.dateInputPlaceholder,
          isCanClear = this.isCanClear,
          onClear = this.onClear;
      var props = {
        disabled: disabled
      };
      var domProps = {
        value: formatValue
      };
      var attrs = {
        type: 'text',
        readonly: true,
        disabled: disabled,
        placeholder: dateInputPlaceholder
      };
      return h("div", {
        "class": pickerClasses
      }, [h("input", _mergeJSXProps([{}, {
        class: pickerInputClass,
        props: props,
        domProps: domProps,
        attrs: attrs
      }])), isCanClear ? h(Icon, {
        "class": "".concat(prefixCls, "-picker-clear"),
        "attrs": {
          "type": "close_circle"
        },
        "on": {
          "click": onClear
        }
      }) : null]);
    },
    renderPopupSlot: function renderPopupSlot() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          normalizeLocale = this.normalizeLocale,
          currentPickerValue = this.currentPickerValue,
          innerValue = this.innerValue,
          format = this.format,
          dateInputPlaceholder = this.dateInputPlaceholder,
          showDateInput = this.showDateInput,
          disabledDate = this.disabledDate,
          onSelect = this.onSelect,
          onUnSelect = this.onUnSelect,
          onPanelChange = this.onPanelChange,
          onOk = this.onOk;
      var props = {
        prefixCls: prefixCls,
        locale: normalizeLocale,
        pickerValue: currentPickerValue,
        selectedValue: innerValue,
        format: format,
        formatSeparator: MULTI_FORMAT_SEPARATOR,
        placeholder: dateInputPlaceholder,
        showDateInput: showDateInput,
        disabledDate: disabledDate
      };
      var on = {
        select: onSelect,
        unselect: onUnSelect,
        'panel-change': onPanelChange,
        ok: onOk
      };
      return h(VMultiCalendar, _mergeJSXProps2([{}, {
        class: "".concat(prefixCls, "-multi"),
        props: props,
        on: on
      }]));
    }
  },
  render: function render() {
    var h = arguments[0];
    var prefixCls = this.prefixCls,
        innerVisible = this.innerVisible,
        disabled = this.disabled,
        align = this.align,
        placement = this.placement,
        builtinPlacements = this.builtinPlacements,
        transitionName = this.transitionName,
        animation = this.animation,
        getPopupContainer = this.getPopupContainer,
        renderTriggerSlot = this.renderTriggerSlot,
        renderPopupSlot = this.renderPopupSlot,
        onVisibleChange = this.onVisibleChange;
    var props = {
      prefixCls: "".concat(prefixCls, "-picker-container"),
      visible: innerVisible,
      disabled: disabled,
      align: align,
      placement: placement,
      builtinPlacements: builtinPlacements,
      transitionName: transitionName,
      animation: animation,
      getPopupContainer: getPopupContainer
    };
    var scopedSlots = {
      trigger: renderTriggerSlot,
      popup: renderPopupSlot
    };
    var on = {
      'visible-change': onVisibleChange
    };
    return h(VPicker, _mergeJSXProps3([{}, {
      props: props,
      scopedSlots: scopedSlots,
      on: on
    }]));
  }
};